import { render, staticRenderFns } from "./VirtualContractEntityDetails.vue?vue&type=template&id=4b82d5d2&"
import script from "./VirtualContractEntityDetails.vue?vue&type=script&lang=js&"
export * from "./VirtualContractEntityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b82d5d2')) {
      api.createRecord('4b82d5d2', component.options)
    } else {
      api.reload('4b82d5d2', component.options)
    }
    module.hot.accept("./VirtualContractEntityDetails.vue?vue&type=template&id=4b82d5d2&", function () {
      api.rerender('4b82d5d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VirtualContractEntityDetails.vue"
export default component.exports